import { useIntl } from "react-intl";
import { InputActionMeta } from "react-select";

import testIds from "constants/testIds";
import Select from "components/v2/Select/Select";
import { stopTestId } from "@RequestFormV2/utils/testIds";
import { StopContactSlice } from "@RequestFormV2/sections/Schedule/hooks/useStopContact";
import { formatContactOptionLabel } from "@RequestFormV2/sections/Schedule/utils/selectOptionLabel";

interface StopContactNameFieldProps {
  contact: StopContactSlice;
  stopIndex: number;
}

export default function StopContactNameField({ contact, stopIndex }: StopContactNameFieldProps) {
  const intl = useIntl();
  const { fieldPaths, contactSearchResults, isLoadingContacts, handleContactSelect, handleContactNameInputChange } = contact;

  return (
    <Select
      name={fieldPaths.stop_contact_name}
      label={intl.formatMessage({ id: "general.name", defaultMessage: "Name" })}
      options={contactSearchResults}
      onChange={handleContactSelect}
      onInputChange={(val: string, meta: InputActionMeta) => handleContactNameInputChange(val, meta)}
      filterOption={() => true}
      isLoading={isLoadingContacts}
      formatOptionLabel={formatContactOptionLabel}
      isClearable
      tabSelectsValue={false}
      testId={stopTestId(testIds.REQUEST_FORM_SCHEDULE_MULTISTOP_STOP_CONTACT_NAME_PREFIX, stopIndex)}
    />
  );
}
